// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Driver from 'driver.js';
import 'driver.js/dist/driver.min.css';
import router from './router'
import axios from 'axios'
import 'signalr'
import i18n from "./i18n/index"



import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';

Vue.use(ViewUI);

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

// 将自动注册所有组件为全局组件
import dataV from '@jiaminghi/data-view'

Vue.use(dataV)

Vue.prototype.$axios = axios
Vue.config.productionTip = false

//vuex
import store from './store'
Vue.prototype.$store = store

Vue.prototype.$driver = new Driver({
  allowClose: false,
	doneBtnText: '完成', // 最后一个按钮的文本
  closeBtnText: '跳过', // 关闭按钮文本
  stageBackground: 'rgba(255, 255, 255, 0.2)', // 高亮显示的元素的背景色
  nextBtnText: '下一步', // 下一步
  prevBtnText: '上一步', // 上一步
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js